import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IDialogView } from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import { Observable, Subject } from 'rxjs';
import { DialogModel } from '@shared/models/dialog.model';
import { Dac6ReporterApiService } from '../../../services/dac6-reporter.service';
import { FormBuilder, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { InvalidateSubject } from '@shared/helpers/invalidate.subject';

@Component({
    standalone: false,
    selector: 'particle-manage-entities-dialog',
  templateUrl: './manage-entities-dialog.component.html',
  styleUrls: ['./manage-entities-dialog.component.scss']
})
export class ManageEntitiesDialogComponent implements OnInit, OnDestroy, IDialogView {
  unSubscribe$ = new Subject<void>();
  data: DialogModel;
  filterId: string;
  leftSourceKey: string;
  filterTemplateId: string;
  endpointName: string;
  rightSourceKey: string;
  invalidateSubject: InvalidateSubject;
  rightSourceType: string;
  leftSourceType: string;
  constructor() {

  }
  ngOnInit() {
    this.filterId = this.data.input.filterId;
    this.leftSourceKey = this.data.input.leftSourceKey;
    this.rightSourceKey = this.data.input.rightSourceKey;
    this.filterTemplateId = this.data.input.filterTemplateId;
    this.endpointName = this.data.input.endpoint;
    this.rightSourceType = this.data.input.rightSourceType;
    this.leftSourceType = this.data.input.leftSourceType;
    this.invalidateSubject = new InvalidateSubject();
  }
  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  onOkClicked(): boolean {
    return true;
  }
}
